/*
 * RIDECLOUD HERO SECTION
 * Style: Original RideCloud — full-width lifestyle photo, warm light overlay on left
 * Text: dark purple on light left side
 * Headline: "Drive It. Love It. Swap It." — large bold dark purple text
 * CTAs: orange pill "Browse Vehicles" + outline "How It Works"
 * Matches original site layout exactly
 */

import { ChevronRight, Play } from "lucide-react";
import TickerBanner from "./TickerBanner";

// Hero backdrop from sandbox.ridecloud.co.za — Backdrop-Main.webp
const HERO_IMAGE = "/hero-backdrop.webp";

export default function HeroSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      className="relative w-full overflow-hidden"
      style={{ minHeight: "calc(100vh - 64px)" }}
    >
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        aria-hidden="true"
      />

      {/* Left-side warm light overlay — matches original site's warm fade from left */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(to right, rgba(248,247,250,0.98) 0%, rgba(248,247,250,0.94) 28%, rgba(248,247,250,0.60) 50%, rgba(248,247,250,0.0) 72%)",
        }}
        aria-hidden="true"
      />

      {/* Content */}
      <div
        className="container relative z-10 flex items-center"
        style={{ minHeight: "calc(100vh - 64px)" }}
      >
        <div className="max-w-lg py-16">
          {/* Headline */}
          <h1
            className="text-5xl md:text-6xl lg:text-7xl font-semibold leading-tight mb-5"
            style={{ color: "#2e004f", fontFamily: "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif" }}
          >
            Drive It.{" "}
            <span style={{ color: "#e6531e" }}>Love It.</span>
            <br />
            Swap It.
          </h1>

          {/* Sub-headline */}
          <p
            className="text-lg md:text-xl mb-8 leading-relaxed"
            style={{ color: "#5a3d70", fontFamily: "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif" }}
          >
            A new way to have a car — built around your life.
          </p>

          {/* CTA buttons */}
          <div className="flex flex-wrap items-center gap-3">
            <button
              onClick={() => scrollTo("#vehicles")}
              className="btn-orange"
            >
              Browse Vehicles
              <ChevronRight className="w-4 h-4" />
            </button>
            <button
              onClick={() => scrollTo("#how-it-works")}
              className="btn-outline-purple"
            >
              <Play className="w-4 h-4" />
              How It Works
            </button>
          </div>

          {/* Tagline */}
          <p className="mt-4 text-base md:text-lg leading-relaxed" style={{ color: "#5a3d70", fontFamily: "ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif" }}>
            Flexible, all-inclusive vehicle subscriptions for people and businesses who don&apos;t want long-term debt.
          </p>
        </div>
      </div>
      {/* Ticker banner pinned to bottom of hero */}
      <div className="absolute bottom-0 left-0 right-0 z-20">
        <TickerBanner />
      </div>
    </section>
  );
}
